import { Injectable } from "@angular/core";
import gql from "graphql-tag";
import { Apollo } from "apollo-angular";
import { Guide } from "../models/guide";
import { Service } from "../models/service";

@Injectable()
export class LanguageService {
  constructor(private apollo: Apollo) {}

  list(obj?) {
    let variables = {};
    console.log("obj", obj);

    if (obj) {
      variables = {
        first: obj.paginationData.pageSize || 10, // Default to 10 if pageSize is not provided
        after: obj.paginationData.after
          ? obj.paginationData.after.endCursor
          : null, // Use null if no cursor is provided
        searchParam: obj.searchParam || null, // Use null if no searchParam is provided
      };
    }
    //TODO: check why all the data disapears in previous
    return this.apollo.watchQuery({
      query: gql`
        query GetLanguages($first: Int, $after: String, $searchParam: String) {
          languages(first: $first, after: $after, searchParam: $searchParam) {
            pageInfo {
              hasNextPage
              endCursor
            }
            edges {
              node {
                id
                name
                slug
              }
              cursor
            }
            totalCount
          }
        }
      `,
      variables,
      errorPolicy: "all",
    }).valueChanges;
  }

  create(language) {
    language.slug = " ";
    return this.apollo.mutate({
      mutation: gql`
        mutation createLanguage($name: String!, $slug: String!) {
          createLanguage(language: { name: $name, slug: $slug }) {
            id
            name
            slug
          }
        }
      `,
      variables: {
        name: language.name,
        slug: language.slug,
      },
    });
  }

  findOne(id: string) {
    return this.apollo.watchQuery({
      query: gql`
        {
          language(id: "${id}") {
            id
            name
            slug
          }
        }
      `,
    }).valueChanges;
  }

  update(language) {
    return this.apollo.mutate({
      mutation: gql`
        mutation updateLanguage($id: String, $name: String, $slug: String) {
          updateLanguage(language: { id: $id, name: $name, slug: $slug }) {
            success
          }
        }
      `,
      variables: {
        id: language.id,
        name: language.name,
        slug: language.slug,
      },
    });
  }

  delete(language) {
    return this.apollo.mutate({
      mutation: gql`
        mutation removeLanguage {
          removeLanguage(language: {id: "${language.id}"}) {
            success
          }
        }
      `,
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/language.service.ts